module.exports = __webpack_public_path__ + "media/images/svgs/jobs/wrench-67dbb9ba4017ec10f0f40433663ec18f.svg";